import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Next steps',
    defaultMessage: 'Next steps',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  linkFieldset: {
    id: 'Link',
    defaultMessage: 'Link',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  intro: {
    id: 'nextSteps.intro',
    defaultMessage: 'Intro',
  },
  introDescription: {
    id: 'nextSteps.introDescription',
    defaultMessage: 'Optional sentence above the milestones.',
  },
  items: {
    id: 'nextSteps.items',
    defaultMessage: 'Milestones',
  },
  item: {
    id: 'nextSteps.item',
    defaultMessage: 'Milestone',
  },
  period: {
    id: 'nextSteps.period',
    defaultMessage: 'When',
  },
  description: {
    id: 'nextSteps.description',
    defaultMessage: 'What',
  },
  linkLabel: {
    id: 'nextSteps.linkLabel',
    defaultMessage: 'Link label',
  },
  link: {
    id: 'nextSteps.link',
    defaultMessage: 'Link',
  },
});

export const NextStepItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.item),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['period', 'description'],
    },
  ],
  properties: {
    period: {
      title: intl.formatMessage(messages.period),
      type: 'string',
    },
    description: {
      title: intl.formatMessage(messages.description),
      type: 'string',
      widget: 'textarea',
    },
  },
  required: [],
});

/**
 * Schema do bloco Next steps — marcos até a Conferência (pedido da UNESCO,
 * 2026-09). `intro` e o link são opcionais: o designer os omitiu no mockup,
 * mas o texto pedido pela UNESCO os inclui — ficam a critério do editor.
 * `title` vazio cai no default i18n "Next Steps" — ver NextStepsBody.
 */
const NextStepsSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['title', 'intro', 'items'],
    },
    {
      id: 'link',
      title: intl.formatMessage(messages.linkFieldset),
      fields: ['linkLabel', 'link'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.title),
      type: 'string',
    },
    intro: {
      title: intl.formatMessage(messages.intro),
      description: intl.formatMessage(messages.introDescription),
      type: 'string',
      widget: 'textarea',
    },
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: NextStepItemSchema({ intl }),
    },
    linkLabel: {
      title: intl.formatMessage(messages.linkLabel),
      type: 'string',
    },
    link: {
      title: intl.formatMessage(messages.link),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
    },
  },
  required: [],
});

export default NextStepsSchema;
